import React from 'react';
import { AnalyticsPage } from '../../pages/AnalyticsPage';

// Admin dashboard "platform-analytics" tab (extracted from AdminPage).
export const AdminPlatformAnalyticsTab = () => (
  <div className="-mx-6">
    <AnalyticsPage />
  </div>
);
